// extracted by mini-css-extract-plugin
module.exports = {"about":"styles_about__2utSz","container":"styles_container__2ESNb","button":"styles_button__1IxNs"};